import React from "react";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./RepresentativeVerificationHeader.css";

/**
 * Public identity-and-authority verification header.
 *
 * The brand row remains centered as one visual unit while it fits. On narrow
 * viewports the logo and trust badge stack instead of wrapping independently.
 *
 * @story layout fullscreen
 * @story title Components/Onboarding/Representative verification header
 * @story token --brand-a2 --brand-a5 --brand-11 --brand-12 --neutral-11
 */
export function RepresentativeVerificationHeader() {
  return (
    <div className="verificationHeaderFrame">
      <header className="verificationHeader">
        <div className="brand" role="group" aria-label="Identidade DaKasa e confiança da sessão">
          <img
            className="logo"
            src={`${window.location.origin}/assets/Logo_DAKASA_V1_Preto.png`}
            alt="DaKasa LTDA"
          />
          <span className="trustBadge">
            <FontAwesomeIcon icon={faLock} /> Sessão protegida e temporária
          </span>
        </div>
        <h1>Confirme sua identidade</h1>
        <p>
          A verificação confirma quem você é e se possui poderes para representar a empresa. A
          organização só será criada depois da aprovação final.
        </p>
      </header>
    </div>
  );
}
